import { IIconProps } from '~/types';
const BdtFlag = (props: IIconProps) => (
  <svg
    width={28}
    height={20}
    viewBox="0 0 28 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <rect width={28} height={20} rx={2} fill="#fff" />
    <mask
      id="a"
      style={{
        maskType: 'luminance',
      }}
      maskUnits="userSpaceOnUse"
      x={0}
      y={0}
      width={28}
      height={20}
    >
      <rect width={28} height={20} rx={2} fill="#fff" />
    </mask>
    <g mask="url(#a)">
      <path fill="#128363" d="M0 0h28v20H0z" />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12.666 16a6 6 0 1 0 0-12 6 6 0 0 0 0 12"
        fill="#F23C53"
      />
    </g>
  </svg>
);
export default BdtFlag;
